module.exports = __webpack_public_path__ + "img/statement__image.b366cba9.svg";